
import {
    Scene,
    PerspectiveCamera,
    AmbientLight,
    PointLight,
    PointLightHelper,
    HemisphereLight,
    HemisphereLightHelper,
    DirectionalLight,
    DirectionalLightHelper,
    WebGLRenderer,
    GridHelper,
    TextureLoader,
    BufferGeometry,
    CircleGeometry,
    FlatShading,
    Float32BufferAttribute,
    MeshMatcapMaterial,
    MeshPhongMaterial,
    ShaderMaterial,
    MeshStandardMaterial,
    MeshBasicMaterial,
    DoubleSide,
    Color,
    Mesh,
    UniformsUtils,
    Group,
    Plane,
    Vector3,
    UniformsLib,
    VSMShadowMap,
    Box3,
    Matrix4,
    Quaternion,
    InstancedMesh,
    TextBufferGeometry,
    FontLoader,
    Raycaster,

    LineBasicMaterial,
    Line,
    PointsMaterial,
    Points,
    SphereGeometry,
    BufferAttribute,
    FrontSide,
    Vector2,
    Shape,
    ShapeGeometry
} from "three"
import { Math as tMath } from "three"
// import * as THREE from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils.js"
import { Line2 } from "three/examples/jsm/lines/Line2.js"
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js"
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js"


import { onUnmounted, reactive, ref, watch, computed } from "vue"
import axios from "axios"
import chroma from "chroma-js"
import validation from "../assets/json/validation.json"
import presets from "../assets/json/presets.json"
import textfont from "../assets/textures/fonts/helvetiker_regular.typeface.json"
import { usePerms } from "../logic/usePerms"

import { useStore } from "vuex"

import { Workbook } from "excel4node"

// import SunCalc from "suncalc"
// import moment from "moment"

let colorScale = {
    BlYlGr: chroma
        .scale(["#0C2C84", "#1E84BA", "#60C1BF", "#D0ECB3", "#FFFFD9"])
        .domain([0, 0.02])
        .classes(5),
    plasma: chroma
        .scale(["#2F0087", "#9F0F9C", "#E67953", "#E4FA15"])
        .domain([0, 0.1])
        .classes(4),
    // plasma: chroma.scale(['#2F0087','#56009D','#7C00A5','#9F0F9C','#BD3386','#D4566C','#E67953','#F1A039','#F1A039','#E4FA15']).domain([0,0.1]).classes(4),
    UDI: chroma
        .scale(["#480054", "#39AEC3", "#F3E91C", "#E73363"])
        .domain([0, 0.1])
        .classes(4),
    DGP: chroma
        .scale(["#C7C7C7", "#FFDB40", "#F79F5C", "#F7515C"])
        .domain([0, 0.05])
        .classes(4),
    ASE: chroma.scale(["#E0E0E0", "#DE2E17"]).domain([0, 0.25]).classes(2),
    pink: chroma
        .scale([
            "#2F0087",
            "#56009D",
            "#7C00A5",
            "#9F0F9C",
            "#BD3386",
            "#D4566C",
            "#E67953",
            "#F1A039",
            "#F1A039",
            "#E4FA15",
        ])
        .domain([0, 0.02])
        .classes(5),
    valid: chroma.scale(["#f05f60", "#13B676"]).domain([0.5, 0.5]).classes(2), //chroma.scale(["#de74ad", "#80bb46"]).domain([0.5, 0.5]).classes(2),
}

export default function useViewer() {
    const { hasPerm, checkToken } = usePerms()
    const store = useStore()

    const token = computed(() => store.getters["auth/token"])
    const host = computed(() => store.getters["auth/host"])

    let scene = {}
    let camera = {}
    let renderer = {}
    let controls = {}
    let clipPlane = {}
    let renderRequested = false
    let mousepos = { mouseX: 0, mouseY: 0 }


    // let objectEX = undefined
    // let planeObjects = undefined

    const selectedData = ref("")
    watch(selectedData, (to, from) => {
        drawResults()
    })

    const knn = (set, target, keys) => {
        const range = {}
        if (set.length < 3) return
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const min = 10000000
            const max = 0
            for (let j = 0; j < set.length; j++) {
                const s = set[j];
                if (s[key] < min) {
                    min = s[key];
                }
                if (s[key] > max) {
                    max = s[key];
                }
            }
            range[key] = max - min
        }
        let arr = set.map(v => {
            let dd = 0
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                dd += Math.pow((v[key] - target[key]) / range[key], 2)
            }
            v.distance = Math.sqrt(dd)
            return v
        })

        arr = arr.sort((a, b) => {
            return a.distance - b.distance
        })
        let k = Math.max(Math.ceil(Math.sqrt(arr.length)) + (1 - Math.ceil(Math.sqrt(arr.length)) % 2), 3)
        // k = 3
        // console.log(k, Math.ceil(Math.sqrt(arr.length)), (1 - Math.ceil(Math.sqrt(arr.length)) % 2))
        const classes = {}
        for (let i = 0; i < arr.length; i++) {
            if (i >= k) { break }
            classes[arr[i].class] = (classes[arr[i].class] || 0) + 1

        }
        // console.log(classes)

        return Object.keys(classes).reduce((a, b) => classes[a] > classes[b] ? a : b);
    }
    const data = []

    const iterations = ref([])

    const northrot = ref(0)

    function fragShade() {
        return `
        varying vec3 vPos;
        // varying vec3 vNormal;
      
        uniform float uTick;
      
        // base color
        const vec3 objColor = vec3(1.0);
        
        
        // hemisphere ground color
        const vec3 hemiLight_g = vec3(0.86,0.86,0.86);
        
        // hemisphere sky color
        const vec3 hemiLight_s_1 = vec3(0.5882352941176471,0.8274509803921568,0.8823529411764706);
        const vec3 hemiLight_s_2 = vec3(0.9686274509803922,0.8509803921568627,0.6666666666666666);
        const vec3 hemiLight_s_3 = vec3(0.8784313725490196,0.5882352941176471,0.7647058823529411);
        
        // directional light color
        const vec3 dirLight = vec3(0.16);
        const vec3 dirLight_2 = vec3(0.02);
      
      
        const vec3 hemiLightPos_1 = vec3(100.0, 100.0, -100.0);
        const vec3 hemiLightPos_2 = vec3(-100.0, -100.0, 100.0);
        const vec3 hemiLightPos_3 = vec3(-100.0, 100.0, 100.0);
      
        const vec3 dirLightPos = vec3(-30, 50, 50);
        const vec3 dirLightPos_2 = vec3(30, -50, -50);
      
        vec3 calcIrradiance_hemi(vec3 newNormal, vec3 lightPos, vec3 grd, vec3 sky){
          float dotNL = dot(newNormal, normalize(lightPos));
          float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
      
          return mix(grd, sky, hemiDiffuseWeight);
        }
      
        vec3 calcIrradiance_dir(vec3 newNormal, vec3 lightPos, vec3 light){
          float dotNL = dot(newNormal, normalize(lightPos));
      
          return light * max(0.0, dotNL);
        }
      
      
        void main(){
      
          float time = uTick * 0.006;
      
          vec3 _normal = normalize(cross(dFdx(vPos), dFdy(vPos)));
      
          vec3 hemiColor = vec3(0.0);
          hemiColor += calcIrradiance_hemi(_normal, hemiLightPos_1, hemiLight_g, hemiLight_s_1) * 0.38;
          hemiColor += calcIrradiance_hemi(_normal, hemiLightPos_2, hemiLight_g, hemiLight_s_2) * 0.26;
          hemiColor += calcIrradiance_hemi(_normal, hemiLightPos_3, hemiLight_g, hemiLight_s_3) * 0.36;
          
          vec3 dirColor = vec3(0.0);
          dirColor += calcIrradiance_dir(_normal, dirLightPos, dirLight);
          dirColor += calcIrradiance_dir(_normal, dirLightPos_2, dirLight_2);
      
      
          vec3 color = objColor * hemiColor;
          
          color += dirColor;
      
      
          gl_FragColor = vec4(color, 1.0);
        }`
    }

    function render() {
        renderRequested = false

        if (cameraTarget != undefined) {
            const pos = camera.position
            const target = new Vector3(
                cameraTarget.pos.x,
                cameraTarget.pos.y + cameraTarget.zoffset,
                cameraTarget.pos.z
            )

            pos.lerp(target, 0.25)

            camera.position.set(pos.x, pos.y, pos.z)
            // camera.position.set(-0.041, 1.9, -1.21);
            controls.target.set(
                pos.x,
                pos.y - cameraTarget.zoffset,
                pos.z + 0.1
            )

            if (target.distanceTo(camera.position) < 0.1) {
                cameraTarget = undefined
                viewMode.value = 0
            }
        }

        controls.update()
        northrot.value =
            Math.round(((controls.getAzimuthalAngle() + Math.PI) / (2 * Math.PI)) * 360)

        renderer.render(scene, camera)
    }

    function onchange() {
        if (!renderRequested) {
            renderRequested = true
            requestAnimationFrame(render)
        }
    }

    let model = new Group()
    let rooms = new Group()
    let results = new Group()
    let curves = new Group()
    let contextMesh = undefined
    onUnmounted(() => {
        model = null
        rooms = null
        results = null
        curves = null
    })

    let textObject = null
    let font = undefined
    let _canvas = {}

    const init = (canvas, options = {}) => {
        _canvas = canvas
        const fontLoader = new FontLoader()
        font = fontLoader.parse(textfont)
        //
        //
        //
        //START FRANZ SUNPATH TEST
        // const points = []
        // var sunpathline = new BufferGeometry().setFromPoints(points);
        // var sunpathmat = new LineBasicMaterial({
        //     color: 'red'
        // });

        // var Latitude = 60.383;//set your latitude
        // var Longitude = 5.328;//set your longitude
        // var distance = 500; //this is the scale of the 3d chart (as a distance from (0,0,0)
        // var d = new Date();//date or you call moment() with no parameters
        // var y = d.getFullYear();//current year ex 2021
        // var day;//variable to hold the date
        // var tempPosition;//variable to hold the position in x,y,z

        // const sunPoints = []

        // for (var m = 1; m < 13; m++) {//loop for each month

        //     day = moment(y + "-01-01", "YYYY-MM-DD");//get a date object
        //     day = day.add(m, 'months');//add one month
        //     // console.log(day)
        //     for (var s = 0; s <= 60; s++) {//loop for 60 minutes

        //         //add minutes to date
        //         day.add(s, 'minutes');
        //         //format date for suncalc use
        //         day.format('YYYY-MM-DD HH:mm:ss');

        //         //get sun position of the sun with Suncalc
        //         var pos = SunCalc.getPosition(day, Latitude, Longitude);
        //         //azimuth and altitude of the sun from suncalc
        //         var azimuth = pos.azimuth * distance;
        //         var altitude = pos.altitude * distance;

        //         //calculate positions as x,y,z coordinates for three.js
        //         //z is rather easy because its only a mater of sin of the angle
        //         var lightZ = distance * Math.sin(altitude * (Math.PI / 180));

        //         //x and y is more complex as you get the distance angle first
        //         var dist = distance * Math.cos(altitude * (Math.PI / 180));
        //         //then you get a sin or cos for x, y parameters
        //         var lightX = -dist * Math.sin(azimuth * (Math.PI / 180));
        //         var lightY = -dist * Math.cos(azimuth * (Math.PI / 180));
        //         tempPosition = [lightX, lightY, lightZ];

        //         // if z dimension to the top positive or rather positive             
        //         if (tempPosition[2] > -10) {
        //             sunPoints.push(tempPosition);
        //             //(y, z, x) = (y to the depth, z to the top, x to the right)
        //             //I am using a three.js vector here
        //             points.push(new Vector3(tempPosition[1], tempPosition[2], tempPosition[0]));
        //         } else {
        //             sunPoints.push([0, 0, 0]);
        //             points.push(new Vector3([0, 0, 0]));
        //         }
        //     }//for minutes loop
        // }//for months loop

        // //name your line and apply material
        // const Sunpath = new Line(sunpathline, sunpathmat);
        // //add it to your scene
        // // scene.add(Sunpath);
        // // console.log(sunPoints)

        // const pointGeo = new BufferGeometry()
        // const vertices = new Float32Array(points)
        // pointGeo.setAttribute('position', new BufferAttribute(vertices, 3))
        // const pointMat = new PointsMaterial({ color: 0xffff00 })
        // const pointMesh = new Points(pointGeo, pointMat)
        // // pointMesh.position.x = points.x
        // // pointMesh.position.y = points.y
        // // pointMesh.position.z = points.z

        //END FRANZ SUNPATH TEST
        //
        //
        //
        // console.log("font")
        textObject = {
            font: font,
            curveSegments: 2,
            bevelEnabled: false,
            bevelThickness: 0.03,
            bevelSize: 0.02,
            bevelOffset: 0,
            bevelSegments: 5,
            height: 0.01,
        }


        scene = new Scene()
        scene.add(model, rooms, results, curves)
        // scene.add(Sunpath, pointMesh)
        if (options.lights != undefined) {

            const lightColor = 0xcccccc

            // const ambientLight = new AmbientLight(lightColor, 0.02)
            // scene.add(ambientLight)


            // LIGHTS



            const hemisphereLight = new HemisphereLight(0x96d3e1, 0xdbdbdb, .5)
            scene.add(hemisphereLight);

            const hemisphereLight2 = new HemisphereLight(0xf7d9aa, 0xdbdbdb, .1)
            scene.add(hemisphereLight2);

            const hemisphereLight3 = new HemisphereLight(0xe096c3, 0xdbdbdb, .15)
            scene.add(hemisphereLight3);

            // const dirLight = new DirectionalLight(0xffffff, 1);
            // dirLight.color.setHSL(0.1, 0, 1);
            // dirLight.position.set(- 1, 1.75, 1);
            // dirLight.position.multiplyScalar(30);
            // dirLight.intensity = 0.98;
            // scene.add(dirLight);

            // dirLight.castShadow = true;

            // dirLight.shadow.mapSize.width = 2048;
            // dirLight.shadow.mapSize.height = 2048;

            // const d = 50;

            // dirLight.shadow.camera.left = - d;
            // dirLight.shadow.camera.right = d;
            // dirLight.shadow.camera.top = d;
            // dirLight.shadow.camera.bottom = - d;

            // dirLight.shadow.camera.far = 3500;
            // dirLight.shadow.bias = - 0.0001;


            const directionalLight = new DirectionalLight(lightColor, 0.6)
            directionalLight.shadow.mapSize.set(
                // canvas.value.clientWidth * 2,
                // canvas.value.clientHeight * 2
                1080 * 4,
                1080 * 4
            )
            directionalLight.shadow.camera.near = 1
            directionalLight.shadow.camera.far = 500
            directionalLight.shadow.camera.left = -250
            directionalLight.shadow.camera.top = 300
            directionalLight.shadow.camera.right = 150
            directionalLight.shadow.camera.bottom = -100
            directionalLight.shadow.radius = 4
            directionalLight.position.set(50, 100, -100)
            directionalLight.lookAt(0, 0, 0)
            directionalLight.castShadow = true
            scene.add(directionalLight)

            const directionalLight2 = new DirectionalLight(0xf7d9aa, 0.65)
            directionalLight2.shadow.mapSize.set(
                // canvas.value.clientWidth * 2,
                // canvas.value.clientHeight * 2
                1080 * 4,
                1080 * 4
            )
            directionalLight2.shadow.camera.near = 1
            directionalLight2.shadow.camera.far = 500
            directionalLight2.shadow.camera.left = -250
            directionalLight2.shadow.camera.top = 300
            directionalLight2.shadow.camera.right = 150
            directionalLight2.shadow.camera.bottom = -100
            directionalLight2.shadow.radius = 4
            directionalLight2.position.set(200, 1000, -10)
            directionalLight2.lookAt(0, 0, 0)
            directionalLight2.castShadow = false
            scene.add(directionalLight2)

        }
        if (options.grid != undefined) {
            const grid = new GridHelper(50, 30)
            scene.add(grid)
        }
        onUnmounted(() => {

            const cleanMaterial = (material) => {
                // console.log("dispose material!")
                material.dispose()

                // dispose textures
                for (const key of Object.keys(material)) {
                    const value = material[key]
                    if (value && typeof value === "object" && "minFilter" in value) {
                        // console.log("dispose texture!")
                        value.dispose()
                    }
                }
            }
            scene.traverse((object) => {
                if (!object.isMesh) return

                // console.log("dispose geometry!")
                object.geometry.dispose()

                if (object.material.isMaterial) {
                    cleanMaterial(object.material)
                } else {
                    // an array of materials
                    for (const material of object.material) cleanMaterial(material)
                }
            })

            scene = null
        })

        clipPlane = new Plane(new Vector3(0, -1, 0), 300)

        const size = {
            width: canvas.value.clientWidth,
            height: canvas.value.clientHeight,
        }
        const aspect = size.width / size.height
        camera = new PerspectiveCamera(55, aspect, 0.1,
            5000)

        camera.position.set(0, 90, -100)
        onUnmounted(() => { camera = null })

        renderer = new WebGLRenderer({
            alpha: true,
            powerPreference: "high-performance",
            preserveDrawingBuffer: true,
        })
        canvas.value.appendChild(renderer.domElement)
        renderer.setSize(size.width, size.height)
        // renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        renderer.setPixelRatio(2)


        renderer.shadowMap.enabled = true
        renderer.shadowMap.type = VSMShadowMap
        renderer.shadowMap.autoUpdate = false
        renderer.shadowMap.needsUpdate = true
        renderer.clippingPlanes = [clipPlane]

        const resize = () => {
            const width = canvas.value.clientWidth
            const height = canvas.value.clientHeight
            camera.aspect = width / height
            camera.updateProjectionMatrix()
            renderer.setSize(width, height)
            if (onchange) {
                onchange()
            }
        }

        window.addEventListener("resize", resize)

        onUnmounted(() => {
            window.removeEventListener("resize", resize)

            renderer.dispose()
            renderer = null
        })


        controls = new OrbitControls(camera, renderer.domElement)
        controls.enableDamping = true
        controls.dampingFactor = 0.25
        controls.maxPolarAngle = (0.85 * Math.PI) / 2
        if (onchange)
            controls.addEventListener("change", onchange)
        onUnmounted(() => {
            if (onchange) {
                controls.removeEventListener("change", onchange)
            }
            controls.dispose()
            controls = null
        })


    }
    const projectInfo = reactive({})
    const resultsData = reactive([])
    const projectConstants = reactive({})
    const floors = reactive([])
    const selectedfloor = ref(0)
    const transparentMode = ref(false)
    const materialMode = ref(false)
    const downloadprogress = ref(0)
    watch(selectedfloor, (to, from) => {
        clipPlane.constant = Number(floors[to])
        if (contextMesh != undefined) {
            contextMesh.material.uniforms.u_cut.value = Number(floors[to])
            contextMesh.material.uniformsNeedUpdate = true
        }
        drawResults()

    })
    watch(transparentMode, (to, from) => {
        model.children.forEach(child => {
            child.material.transparent = transparentMode.value
            // console.log(child)
            if (transparentMode.value) {
                if (child.name.toLocaleLowerCase().includes("terrain") ||
                    child.name.toLocaleLowerCase().includes("ground")) {

                } else {

                    child.material.opacity = 0.1
                }

            } else {
                if (child.name.toLocaleLowerCase().includes("window") ||
                    child.name.toLocaleLowerCase().includes("glass")) {
                    child.material.opacity = 0.2
                    child.material.transparent = true
                } else {
                    child.material.opacity = 1
                }

            }
        })
        drawResults()
    })

    // watch(materialMode, (to, from) => {
    //     model.children.forEach(child => {
    //         console.log(child.userData)
    //         if (materialMode.value) {
    //             if (child.name.toLocaleLowerCase().includes("terrain") ||
    //                 child.name.toLocaleLowerCase().includes("ground")) {

    //                 // model.children.indexOf(child)
    //                 // mesh.material.uniforms.color = 

    //             } else {

    //                 child.material.opacity = 0.1
    //             }

    //         } else {
    //             if (child.name.toLocaleLowerCase().includes("window") ||
    //                 child.name.toLocaleLowerCase().includes("glass")) {
    //                 child.material.opacity = 0.2
    //                 child.material.transparent = true
    //             } else {
    //                 child.material.opacity = 1
    //             }

    //         }
    //     })
    //     drawResults()
    // })

    const roomNames = ref([])
    const roomNamesnotsim = ref([])
    const validations = reactive({})

    const materials = ref([])


    const getboundingbox = (points) => {
        for (let i = 0; i < points.length - 1; i++) {
            const point1 = points[i];
            const point2 = points[i + 1];
        }

        const s = Math.sin(angle);
        const c = Math.cos(angle);

        // translate point back to origin:
        p.x -= cx;
        p.y -= cy;

        // rotate point
        const xnew = p.x * c - p.y * s;
        const ynew = p.x * s + p.y * c;

        // translate point back:
        p.x = xnew + cx;
        p.y = ynew + cy;
        return p;
    }
    let _jobId = undefined

    const round = (value, desimals) => {
        const mul = desimals != 0 ? Math.pow(10, desimals) : 1
        return Math.round(value * mul) / mul
    }

    const loadModel = async (jobId) => {

        let haveimage = false
        const apiurl = "https://api.otonomi.no"
        // const apiurl = "http://localhost:8085/"
        // get job and project data handle no access with 

        _jobId = jobId ? jobId : undefined
        const baseurl = jobId == undefined ? "/demo" : `/job/files/${jobId}`



        // const apiurl = "http://localhost:8085"
        // cleanup
        let selectedvalidations = ["TEK 17", "EN 17037", "svaneNOR"]
        let projectId = ""
        if (jobId != undefined) {
            await axios({
                baseURL: apiurl,
                url: `job/iterations/${jobId}`,
                method: "Get",
            })
                .then((res) => {
                    return res.data
                })
                .then((data) => {
                    // console.log(data)
                    iterations.value = data.iterations
                    projectId = data.projectId
                    haveimage = data.haveimage ? true : false
                    // console.log(data.validations)
                    if (data.validations != undefined && data.validations.length > 0) {
                        selectedvalidations = data.validations
                    }
                })
        }
        // console.log(selectedvalidations)
        // console.log(jobId, baseurl)

        model.children.forEach((ch) => {
            model.remove(ch)
            ch.geometry.dispose()
            ch.material.dispose()
        })
        rooms.children.forEach((ch) => {
            rooms.remove(ch)
            ch.geometry.dispose()
            ch.material.dispose()
        })
        await axios({
            baseURL: apiurl,
            url: `${baseurl}/project`,
            method: "Get",
        })
            .then((res) => {
                return res.data
            })
            .then((projectI) => {
                // console.log(projectI)
                projectInfo.name = projectI.projectName
                projectInfo.number = projectI.projectNumber
                projectInfo.location = projectI.location
                projectInfo.longlat = projectI.longlat
                projectInfo.materials = projectI.materials
                projectInfo.LRLT = projectI.LRLT

                projectInfo.schedule = projectI.schedule
                projectInfo.validations = selectedvalidations// ["TEK17", "EN17037", "BREEAM2021"]

                const series = []
                let a = projectI.schedule
                for (let i = 0; i < 24; i++) {
                    const metric = { name: i.toFixed(0), data: a.splice(0, 365) }
                    series.push(metric)
                }
                //   series = series

                projectConstants.medianDifIll = projectI.diffuseIlluminance.sort(
                    (a, b) => {
                        return b - a
                    }
                )[2190]
                projectConstants.MINDtm = 100 / projectConstants.medianDifIll
                projectConstants.MINDt = 300 / projectConstants.medianDifIll
                projectConstants.MEDDtm = 300 / projectConstants.medianDifIll
                projectConstants.MEDDt = 500 / projectConstants.medianDifIll
                projectConstants.HIGHDtm = 500 / projectConstants.medianDifIll
                projectConstants.HIGHDt = 750 / projectConstants.medianDifIll

                if (projectId == "6141b20ce7ae3c4cbc077c97") {
                    projectConstants.MINDtm = 0.008
                    projectConstants.MINDt = 0.024
                }
                // resultsData = []

            })

            .catch((err) => {
                console.log(err)
            })
        console.log("project info loaded")

        const totalstore = {}
        const loadedstore = {}
        const handleprogress = (progressEvent, name) => {
            // console.log(progressEvent)
            totalstore[name] = progressEvent.total
            loadedstore[name] = progressEvent.loaded

            const total = Object.keys(totalstore).reduce(
                (sum, key) => sum + parseFloat(totalstore[key] || 0),
                0
            )
            const loaded = Object.keys(loadedstore).reduce(
                (sum, key) => sum + parseFloat(loadedstore[key] || 0),
                0
            )
            var percentCompleted = Math.round((loaded * 100) / total)
            downloadprogress.value = Math.min(percentCompleted, 100)
        }


        const loadgeo = () => {
            return axios({
                baseURL: apiurl,
                url: `${baseurl}/geo`,
                method: "Get",
                onDownloadProgress: (pevent) => {
                    handleprogress(pevent, "geo")
                },
            })
                .then((res) => {
                    return res.data
                    //   return res.json()
                })
                .then((data) => {
                    const _materials = []
                    const textureLoader = new TextureLoader()

                    const matcapTexture = textureLoader.load(
                        require("../assets/textures/matcaps/20.png")
                    )

                    // function createPlaneStencilGroup(geometry, plane, renderOrder) {

                    //     const group = new THREE.Group();
                    //     const baseMat = new THREE.MeshBasicMaterial();
                    //     baseMat.depthWrite = false;
                    //     baseMat.depthTest = false;
                    //     baseMat.colorWrite = false;
                    //     baseMat.stencilWrite = true;
                    //     baseMat.stencilFunc = THREE.AlwaysStencilFunc;

                    //     // back faces
                    //     const mat0 = baseMat.clone();
                    //     mat0.side = THREE.BackSide;
                    //     mat0.clippingPlanes = [clipPlane];
                    //     mat0.stencilFail = THREE.IncrementWrapStencilOp;
                    //     mat0.stencilZFail = THREE.IncrementWrapStencilOp;
                    //     mat0.stencilZPass = THREE.IncrementWrapStencilOp;

                    //     const mesh0 = new THREE.Mesh(geometry, mat0);
                    //     mesh0.renderOrder = renderOrder;
                    //     group.add(mesh0);

                    //     // front faces
                    //     const mat1 = baseMat.clone();
                    //     mat1.side = THREE.FrontSide;
                    //     mat1.clippingPlanes = [clipPlane];
                    //     mat1.stencilFail = THREE.DecrementWrapStencilOp;
                    //     mat1.stencilZFail = THREE.DecrementWrapStencilOp;
                    //     mat1.stencilZPass = THREE.DecrementWrapStencilOp;

                    //     const mesh1 = new THREE.Mesh(geometry, mat1);
                    //     mesh1.renderOrder = renderOrder;

                    //     group.add(mesh1);

                    //     return group;

                    // }
                    // object = new THREE.Group();
                    // model.add(object);
                    // const geometry = []
                    // const stencilGroup = createPlaneStencilGroup(geometry, clipPlane, 1)
                    // const planeMat =
                    //     new THREE.MeshStandardMaterial({

                    //         color: 0xE91E63,
                    //         metalness: 0.1,
                    //         roughness: 0.75,
                    //         clippingPlanes: [clipPlane],

                    //         stencilWrite: true,
                    //         stencilRef: 0,
                    //         stencilFunc: THREE.NotEqualStencilFunc,
                    //         stencilFail: THREE.ReplaceStencilOp,
                    //         stencilZFail: THREE.ReplaceStencilOp,
                    //         stencilZPass: THREE.ReplaceStencilOp,

                    //     });
                    // const po = new THREE.Mesh(planeGeom, planeMat);
                    // po.onAfterRender = function (renderer) {

                    //     renderer.clearStencil();

                    // };
                    // po.renderOrder = 1.1;

                    // object.add(stencilGroup);
                    // poGroup.add(po);
                    // planeObjects.push(po);
                    // model.add(poGroup);

                    // const material = new THREE.MeshStandardMaterial({

                    //     color: 0xFFC107,
                    //     metalness: 0.1,
                    //     roughness: 0.75,
                    //     clippingPlanes: planes,
                    //     clipShadows: true,
                    //     shadowSide: THREE.DoubleSide,

                    // });

                    // add the color
                    // const clippedColorFront = new THREE.Mesh(geometry, material);
                    // clippedColorFront.castShadow = true;
                    // clippedColorFront.renderOrder = 6;
                    // object.add(clippedColorFront);

                    for (let i = 0; i < data.length; i++) {
                        const object = data[i]
                        const geom = new BufferGeometry()
                        geom.setIndex(object.faces)
                        geom.setAttribute(
                            "position",
                            new Float32BufferAttribute(object.points, 3)
                        )
                        geom.name = object.names
                        geom.computeVertexNormals()
                        geom.computeFaceNormals()
                        // geometry.push(geom)
                        const cs = chroma
                            .scale(["#7C7C7C", "#FFFFFF"])
                            .domain([0, 100])
                            .classes(20)(object.colors[0])
                            .rgb()
                        const color = new Color(cs[0] / 255, cs[1] / 255, cs[2] / 255)
                        // const color = new Color(object.colors[0]/255,object.colors[1]/255,object.colors[2]/255)

                        const material = new MeshMatcapMaterial({
                            side: DoubleSide,
                            matcap: matcapTexture,
                            color: color,
                            depthTest: true,
                            depthWrite: true,
                            transparent: false,
                            // opacity: 1 - object.transparency,
                            clippingPlanes: [clipPlane],
                        })
                        const mat = { name: object.names }
                        if (object.names == "Windows") {
                            mat.LRLT =
                                (Math.round((object.transparency * 100) / 5) * 5).toFixed(0)

                        } else {
                            mat.LRLT =
                                (Math.round((object.transparency * 100) / 5) * 5).toFixed(0)

                        }
                        _materials.push(mat)
                        const mesh = new Mesh(geom, material)
                        mesh.name = geom.name

                        if (geom.name.toLocaleLowerCase().includes("window") ||
                            geom.name.toLocaleLowerCase().includes("glass")) {
                            // mesh.attributes.uv2 = mesh.attributes.uv

                            mesh.material = new MeshPhongMaterial({
                                side: DoubleSide,
                                color: "lightblue",
                                fog: true,
                                // metalness: 0,
                                // roughness: 1,
                                emissive: "black",
                                emissiveIntensity: 500,
                                wireframe: false,
                                transparent: true,
                                opacity: 0.2,
                                clippingPlanes: [clipPlane],
                            })
                            mesh.castShadow = false
                            mesh.receiveShadow = false
                            // console.log("windows updated")
                        }
                        if (geom.name.toLocaleLowerCase().includes("ground")) {
                            const uniforms = UniformsUtils.merge([
                                UniformsLib["common"],
                                UniformsLib["specularmap"],
                                UniformsLib["envmap"],
                                UniformsLib["aomap"],
                                UniformsLib["lightmap"],
                                UniformsLib["emissivemap"],
                                UniformsLib["fog"],
                                UniformsLib["lights"],
                            ])
                            const vshader1 =
                                "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvPosition = position;\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}"
                            // const fshader =
                            "uniform vec3 diffuse;\nuniform float u_cut;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tif ( vPosition.y < (u_cut + 0.05) && vPosition.y > (u_cut - 0.05) )\n\t\toutgoingLight = vec3(5./255., 1./255., 1.);\n\t\tdiffuseColor.a = float(1.);\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}"

                            const fshader1 =
                                "uniform vec3 diffuse;\nuniform float u_cut;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tif ( vPosition.y < (u_cut + 0.05) && vPosition.y > (u_cut - 0.05) )\n\t\toutgoingLight = vec3(5./255., 1./255., 1.);\n\t\tdiffuseColor.a = float(1.);\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}"
                            // "uniform vec3 diffuse;\nuniform float u_cut;\nuniform vec3 color;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tif ( vPosition.y < (u_cut + 0.05) && vPosition.y > (u_cut - 0.05) )\n\t\toutgoingLight = vec3(.59, .59, .59);\n\t\tdiffuseColor.a = float(1.);\n\tgl_FragColor = vec4( color, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}"

                            // const fshader = fragShade()
                            // console.log(color)
                            mesh.material = new ShaderMaterial({
                                side: DoubleSide,
                                lights: true,
                                color: "0x000000",
                                fog: false,
                                shading: FlatShading,
                                metalness: 1,
                                roughness: 1,
                                emissive: "black",
                                wireframe: false,
                                uniforms: uniforms,
                                vertexShader: vshader1,
                                fragmentShader: fshader1,
                            })
                            mesh.material.uniforms.u_cut = { value: 300 }
                            mesh.material.uniforms.color = { value: color }
                            mesh.receiveShadow = true
                            mesh.material.shadowSide = DoubleSide
                        }
                        // const re = /(Context*)\w+/gi
                        // if (re.test(geom.name)) {
                        if (geom.name == "Context") {
                            contextMesh = mesh
                            const uniforms = UniformsUtils.merge([
                                UniformsLib["common"],
                                UniformsLib["specularmap"],
                                UniformsLib["envmap"],
                                UniformsLib["aomap"],
                                UniformsLib["lightmap"],
                                UniformsLib["emissivemap"],
                                UniformsLib["fog"],
                                UniformsLib["lights"],
                            ])
                            const vshader =
                                "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvPosition = position;\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}"
                            // const fshader =
                            "uniform vec3 diffuse;\nuniform float u_cut;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tif ( vPosition.y < (u_cut + 0.05) && vPosition.y > (u_cut - 0.05) )\n\t\toutgoingLight = vec3(55./255., 81./255., 1.);\n\t\tdiffuseColor.a = float(1.);\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}"

                            const fshader =
                                "uniform vec3 diffuse;\nuniform float u_cut;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vPosition;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tif ( vPosition.y < (u_cut + 0.05) && vPosition.y > (u_cut - 0.05) )\n\t\toutgoingLight = vec3(55./255., 81./255., 1.);\n\t\tdiffuseColor.a = float(1.);\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}"

                            // const fshader = fragShade()

                            mesh.material = new ShaderMaterial({
                                side: DoubleSide,
                                lights: true,
                                color: "#FFFFF9",
                                fog: false,
                                shading: FlatShading,
                                metalness: 0.5,
                                roughness: 0.5,
                                emissive: "black",
                                wireframe: false,
                                uniforms: uniforms,
                                vertexShader: vshader,
                                fragmentShader: fshader,
                            })
                            mesh.material.uniforms.u_cut = { value: 300 }
                            mesh.receiveShadow = true
                            mesh.material.shadowSide = DoubleSide
                        }
                        mesh.castShadow = true
                        mesh.receiveShadow = true

                        model.add(mesh)

                        materials.value = _materials
                        // materials = materialName
                        // LRLT = materialLRLT
                    }
                    renderer.shadowMap.needsUpdate = true
                    console.log("model loaded")
                })

                .catch((err) => {
                    console.log(err)
                })
        }
        const loadrooms = () => {
            return axios({
                baseURL: apiurl,
                url: `${baseurl}/rooms`,
                method: "Get",
                onDownloadProgress: (pevent) => {
                    handleprogress(pevent, "rooms")
                },
            })
                .then((res) => {
                    return res.data
                })
                .then((data) => {
                    // console.log(data)
                    //resultsData = []
                    roomNamesnotsim
                    let namesnotsim = new Set()

                    for (let i = 0; i < data.length; i++) {
                        const room = data[i]
                        if (typeof room.userData == "string")
                            room.userData = JSON.parse(room.userData)
                        if (room.userData.selected == 0) {
                            namesnotsim.add(room.userData.names)

                            continue
                        }
                        // console.log(room.userData.selected.length)
                        // room.userData.curvePoints = room.curvePoints
                        // console.log(room.userData.name)
                        if (room.userData.names) {

                            room.userData.names = room.userData.names.replace('\\X2\\00F8\\X0\\', "ø")
                        }

                        room.userData.DF_average =
                            room.userData.DF_values.reduce((a, b) => a + b, 0) /
                            room.userData.DF_values.length
                        room.userData.DF_median =
                            [...room.userData.DF_values].sort()[Math.round(room.userData.DF_values.length / 2)]
                        room.userData.DF_min = Math.min(...room.userData.DF_values)
                        room.userData.DA100_average =
                            room.userData.DA100_values.reduce((a, b) => a + b, 0) /
                            room.userData.DA100_values.length
                        room.userData.DA300_average =
                            room.userData.DA300_values.reduce((a, b) => a + b, 0) /
                            room.userData.DA300_values.length
                        room.userData.csDA =
                            room.userData.cDA300_values.filter((v) => v >= 0.5).length /
                            room.userData.cDA300_values.length
                        // const cDA = room.userData.cDA300_values.reduce((a, b) => a + b, 0)/room.userData.cDA300_values.length
                        room.userData.sDA100 =
                            room.userData.DA100_values.filter((v) => v >= 0.5).length /
                            room.userData.DA100_values.length
                        room.userData.sDA300 =
                            room.userData.DA300_values.filter((v) => v >= 0.5).length /
                            room.userData.DA300_values.length
                        room.userData.ASE_average = room.userData.ASE_values.filter((v) => v >= 250).length / room.userData.ASE_values.length
                        room.userData.UDI_average =
                            (room.userData.UDI_values.accept.reduce((a, b) => a + b, 0) /
                                room.userData.UDI_values.accept.length) + (room.userData.UDI_values.sup.reduce((a, b) => a + b, 0) /
                                    room.userData.UDI_values.sup.length * 0.5)
                        room.userData.valids = {}


                        room.userData.data = {
                            DFmin: Math.min(...room.userData.DF_values),
                            DFmedian: [...room.userData.DF_values].sort()[Math.round(room.userData.DF_values.length / 2)],
                            DFaverage: room.userData.DF_values.reduce((a, b) => a + b, 0) / room.userData.DF_values.length,
                            DFmax: Math.max(...room.userData.DF_values),
                            UDIfail: room.userData.UDI_values.fail.reduce((a, b) => a + b, 0) / room.userData.UDI_values.fail.length,
                            UDIsup: room.userData.UDI_values.sup.reduce((a, b) => a + b, 0) / room.userData.UDI_values.sup.length,
                            UDIaccept: room.userData.UDI_values.accept.reduce((a, b) => a + b, 0) / room.userData.UDI_values.accept.length,
                            UDIexcess: room.userData.UDI_values.excess.reduce((a, b) => a + b, 0) / room.userData.UDI_values.excess.length,
                            sDA100: room.userData.DA100_values.filter((v) => v >= 0.5).length /
                                room.userData.DA100_values.length,

                            sDA300: room.userData.DA300_values.filter((v) => v >= 0.5).length /
                                room.userData.DA300_values.length,
                            ASE: room.userData.ASE_values.filter((v) => v >= 250).length / room.userData.ASE_values.length
                        }
                        if (room.userData.DA200_values) {
                            room.userData.DA200_average =
                                room.userData.DA200_values.reduce((a, b) => a + b, 0) /
                                room.userData.DA200_values.length
                            room.userData.data.sDA200 = room.userData.DA200_values.filter((v) => v >= 0.5).length /
                                room.userData.DA200_values.length
                        }
                        if (room.userData.DA120_values) {
                            room.userData.DA120_average =
                                room.userData.DA120_values.reduce((a, b) => a + b, 0) /
                                room.userData.DA120_values.length
                            room.userData.data.sDA120 = room.userData.DA120_values.filter((v) => v >= 0.5).length /
                                room.userData.DA120_values.length
                        }

                        room.userData.recomend = undefined
                        room.userData.recomendchange = false




                        for (const key in validation) {

                            if (selectedvalidations.includes(key)) {
                                validations[key] = validation[key]
                            }



                            const val = validation[key]
                            const met = val.method == undefined ? "max" : val.method
                            let points = 0
                            room.userData.valids[key] = { methods: [] }
                            for (let m = 0; m < val.methods.length; m++) {
                                const method = val.methods[m]
                                let pass = 0
                                let point = method.points == undefined ? 1 : method.points
                                const getspoint = true
                                const values = []
                                // console.log(method)
                                for (const r in method.req) {
                                    const req = method.req[r]
                                    if (!room.userData[req.metric + "_values"]) {
                                        break
                                    }
                                    const value = 0
                                    const roundvalue = req.acc || 2
                                    const min =
                                        typeof req.min == "string"
                                            ? projectConstants[req.min]
                                            : req.min
                                    validation[key].methods[m].req[r]["cMin"] = min
                                    // validations[key].methods[m].req[r]["cMin"] = min
                                    const max =
                                        typeof req.max == "string"
                                            ? projectConstants[req.max]
                                            : req.max
                                    if (req.value == "spatial") {
                                        let notvalid = 0

                                        if (min != undefined) {
                                            notvalid += room.userData[req.metric + "_values"].filter(
                                                (v) => v < min
                                            ).length
                                        }
                                        if (max != undefined) {
                                            notvalid += room.userData[req.metric + "_values"].filter(
                                                (v) => v > max
                                            ).length
                                        }
                                        const perse =
                                            (room.userData[req.metric + "_values"].length - notvalid) /
                                            room.userData[req.metric + "_values"].length

                                        values.push(perse)
                                        if (round(perse, roundvalue) >= req["min%"]) {
                                            pass += 1
                                            continue
                                        }

                                        continue
                                    }
                                    // const roundvalue = req.value == "spatial" ? 2 : 3
                                    // roundvalue = req.metric == "UDI" ? 2 : roundvalue


                                    values.push(round(room.userData[req.metric + "_" + req.value], roundvalue))
                                    if (min != undefined && max == undefined) {
                                        if (round(room.userData[req.metric + "_" + req.value], roundvalue) >= min) {
                                            pass += 1
                                            continue
                                        }
                                    }
                                    if (min == undefined && max != undefined) {

                                        if (round(room.userData[req.metric + "_" + req.value], roundvalue) <= max) {
                                            pass += 1
                                            continue
                                        }
                                    }
                                    if (min != undefined && max != undefined) {
                                        if (
                                            round(room.userData[req.metric + "_" + req.value], roundvalue) <= max &&
                                            round(room.userData[req.metric + "_" + req.value], roundvalue) >= min
                                        ) {
                                            pass += 1
                                            continue
                                        }
                                    }
                                }
                                room.userData.valids[key].methods.push(values)
                                if (method.req.length == pass) {
                                    if (met == "max") {
                                        if (point > points) {
                                            points = point
                                        }
                                        continue
                                    }
                                    if (met == "sum") {
                                        points += point
                                    }
                                }
                            }
                            // console.log(val.name, points)
                            room.userData.valids[key].points = points
                        }
                        const valid = room.userData.valids["TEK 17"].points

                        room.userData["-Valid_values"] = valid
                        let color = colorScale.valid(valid).rgb()

                        // console.log(room.userData.curvePoints)

                        const pts = []
                        for (let l = 0; l < room.userData.curvePoints.length; l += 3) {
                            pts.push(new Vector2(room.userData.curvePoints[l], room.userData.curvePoints[l + 2]))
                        }
                        const shape = new Shape(pts)

                        const geo = new ShapeGeometry(shape)
                        geo.rotateX(tMath.degToRad(90))
                        geo.translate(0, room.userData.curvePoints[1] + 0.05, 0)
                        const mat = new MeshBasicMaterial({ color: 'blue', side: DoubleSide, transparent: true, opacity: 0.2, depthTest: true })
                        // let mesh = new Mesh(geo, mat)
                        // scene.add(mesh)


                        // const geom = new BufferGeometry()
                        // geom.setIndex(room.faces)
                        // geom.setAttribute(
                        //     "position",
                        //     new Float32BufferAttribute(room.points, 3)
                        // )
                        color = new Color(color[0] / 255, color[1] / 255, color[2] / 255)
                        const material = new MeshBasicMaterial({
                            side: DoubleSide,
                            color: color,
                            toneMapped: false,
                        })
                        const mesh = new Mesh(geo, material)
                        // rooms.position.set(0, -0.8, 0)
                        mesh.userData = room.userData
                        rooms.add(mesh)
                        room.userData.mesh = mesh

                        resultsData.push(room.userData)
                        // console.log(room.userData)
                        // console.log(resultsData)
                    }


                    projectInfo.valids = {}
                    for (const key in validation) {
                        let pass = 0
                        for (let r = 0; r < rooms.children.length; r++) {
                            const room = rooms.children[r]

                            if (room.userData.valids[key].points > 0) {
                                pass += 1
                            }
                        }
                        const persent = pass / rooms.children.length
                        projectInfo.valids[key] = persent
                        // console.log(key, (persent * 100).toFixed(1) + "%")
                    }

                    let _floors = new Set()
                    const types = new Set()
                    let names = new Set()
                    for (let key in resultsData[0]) {
                        if (
                            key != "SensorPoints" &&
                            key != "names" &&
                            key != "mesh" &&
                            key != "area"
                        ) {
                            if (key.split("_").length > 1) [(key = key.split("_")[0])]

                            types.add(key)
                            if (key == "DA100") {
                                types.add("sDA100")
                            }
                            if (key == "DA300") {
                                types.add("sDA300")
                            }
                        }
                    }

                    for (let id = 0; id < resultsData.length; id++) {
                        const element = resultsData[id]
                        _floors.add(Number(element.SensorPoints[0][1].toFixed(2)) + 0.75)
                        names.add(element.names)
                    }
                    let valids = [...Array(resultsData.length).keys()]
                    valids = valids.sort((a, b) => {
                        return (
                            resultsData[a]["-Valid_values"] -
                            resultsData[b]["-Valid_values"]
                        )
                    })
                    // console.log(valids)

                    namesnotsim = [...namesnotsim].sort()
                    roomNamesnotsim.value = namesnotsim

                    names = [...names].sort()
                    roomNames.value = names
                    // console.log(_floors)
                    _floors = [..._floors].sort((a, b) => {
                        return Number(a) - Number(b)
                    })
                    _floors.push(300)
                    // console.log(_floors)
                    const keys = []
                    for (const key in validation) {
                        if (selectedvalidations.includes(key)) {
                            keys.push(key)
                        }

                    }
                    selectedData.value = keys[0]
                    selStandard.value = keys[0]
                    floors.push(..._floors)

                    selectedfloor.value = floors.length - 1
                    camera.position.set(0, 90 + _floors[0], -100)

                    controls.target.set(
                        0,
                        _floors[0],
                        0
                    )
                    sortrooms()
                    console.log("results loaded")
                    console.log('have image:', haveimage)


                })
                .catch((err) => {
                    console.log(err.message)
                    throw err;
                })
        }

        const resultArray = await Promise.all([, loadgeo(), loadrooms()])
        resultArray
        if (!haveimage) {
            onchange()
            setTimeout(() => {
                const data = screenshot(1600, 900)
                // console.log(data)

            }, 1000)

        }
    }

    const saveScreenshot = async (event, width, height) => {
        if (width && height) {
            const data = screenshot(width, height)
            const url = "https://api.otonomi.no"

            await checkToken()
            if (hasPerm("system.admin") && _jobId) {
                axios({
                    baseURL: url,
                    url: `/job/image/${_jobId}`,
                    data: {
                        image: data,
                    },
                    method: "post",
                    headers: {
                        Authorization: "Bearer " + token.value,
                    },
                })
                    .then((resp) => {
                        console.log("sent")
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }

        } else {

            screenshot()
        }
    }


    const getValue = (room, req) => {
        let roundvalue = req.acc || 2
        const min =
            typeof req.min == "string"
                ? projectConstants[req.min]
                : req.min
        req["cMin"] = min
        const max =
            typeof req.max == "string"
                ? projectConstants[req.max]
                : req.max
        if (req.value == "spatial") {
            roundvalue = 2
            let notvalid = 0
            if (min != undefined) {
                notvalid += room.userData[req.metric + "_values"].filter(
                    (v) => v < min
                ).length
            }
            if (max != undefined) {
                notvalid += room.userData[req.metric + "_values"].filter(
                    (v) => v > max
                ).length
            }
            const perse =
                (room.userData[req.metric + "_values"].length - notvalid) /
                room.userData[req.metric + "_values"].length
            return round(perse, roundvalue)
        }
        return round(room.userData[req.metric + "_" + req.value], roundvalue)
    }

    const createExcel = async () => {

        const wb = new Workbook()
        const ws = wb.addWorksheet('Sheet 1')
        const categories = []

        console.log("validation", validations[selStandard.value])
        validations[selStandard.value].methods.forEach((method, i) => {
            categories.push(method)
        })
        let ci = 5
        const passStyle = wb.createStyle({
            fill: {
                type: 'pattern',
                patternType: 'solid',
                bgColor: 'C7EFCE'
            },
        });
        // red background
        const failStyle = wb.createStyle({
            fill: {
                type: 'pattern',
                patternType: 'solid',
                bgColor: 'FFC7CE'
            },
        });

        for (let i = 0; i < categories.length; i++) {
            // center and border and set width to fit 
            const collumnLength = categories[i].name.length / categories[i].req.length
            ws.cell(1, ci, 1, ci + categories[i].req.length - 1, true).string(categories[i].name).style({
                alignment: { horizontal: 'center' },
                border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

            })


            for (let j = 0; j < categories[i].req.length; j++) {
                const req = categories[i].req[j]
                ws.column(ci + j).setWidth(Math.max(collumnLength, 10))
                // green background

                // range string
                const range = `${String.fromCharCode(65 + ci + j - 1)}3:${String.fromCharCode(65 + ci + j - 1)}${rooms.children.length + 2}`


                const min = req.value == "spatial" ? req["min%"] : req.min
                ws.addConditionalFormattingRule(range, {
                    // apply ws formatting ref 'A1:A10'
                    type: 'expression', // the conditional formatting type
                    priority: j + 1, // rule priority order (required)
                    // greater than 0.5
                    formula: `${String.fromCharCode(65 + ci + j - 1)}3>=${min}`,
                    style: passStyle, // a style object containing styles to apply
                });
                ws.addConditionalFormattingRule(range, {
                    // apply ws formatting ref 'A1:A10'    
                    type: 'expression', // the conditional formatting type
                    priority: j + 1, // rule priority order (required)
                    // greater than 0.5
                    formula: `${String.fromCharCode(65 + ci + j - 1)}3<${min}`,
                    style: failStyle, // a style object containing styles to apply
                });
            }

            ci += categories[i].req.length
        }
        const range = `${String.fromCharCode(65 + ci - 1)}3:${String.fromCharCode(65 + ci - 1)}${rooms.children.length + 2}`
        console.log('range', range);
        ws.addConditionalFormattingRule(range, {
            // apply ws formatting ref 'A1:A10'
            type: 'expression', // the conditional formatting type
            priority: 1, // rule priority order (required)
            // greater than 0.5
            formula: `${String.fromCharCode(65 + ci - 1)}3 = "PASS"`,
            style: passStyle, // a style object containing styles to apply
        });
        ws.addConditionalFormattingRule(range, {
            // apply ws formatting ref 'A1:A10'
            type: 'expression', // the conditional formatting type
            priority: 1, // rule priority order (required)
            // greater than 0.5
            formula: `${String.fromCharCode(65 + ci - 1)}3 = "FAIL"`,
            style: failStyle, // a style object containing styles to apply
        });



        const header = [
            "Floor",
            "number",
            "name",
            "Area",
        ]
        for (let i = 0; i < categories.length; i++) {
            for (let j = 0; j < categories[i].req.length; j++) {
                if (categories[i].req[j].short) {
                    header.push(categories[i].req[j].short)
                    continue
                }
                if (categories[i].req[j].value == "spatial") {
                    header.push(categories[i].req[j].metric + "spatial")
                } else {
                    header.push(categories[i].req[j].metric + categories[i].req[j].value)
                }
            }

        }

        for (let i = 0; i < header.length; i++) {
            ws.cell(2, i + 1).string(header[i])
        }





        for (let i = 0; i < rooms.children.length; i++) {
            const room = rooms.children[i]
            console.log("room", room)
            const row = [
                round(room.userData.SensorPoints[0][1], 1),
                room.userData.IFCname,
                room.userData.names,
                round(room.userData.area, 2),
            ]
            const rowdata = []
            let rowformula = '=IF(OR('
            let ci = 5
            for (let j = 0; j < categories.length; j++) {
                if (categories[j].req.length > 1) {
                    rowformula += 'AND('
                }
                for (let k = 0; k < categories[j].req.length; k++) {
                    const req = categories[j].req[k]
                    const min = req.value == "spatial" ? req["min%"] : req.min
                    rowdata.push({ value: getValue(room, req), acc: req.value == "spatial" ? 2 : req.acc })
                    rowformula += `${String.fromCharCode(65 + ci - 1)}${3 + i}>=${min},`
                    ci++

                }
                if (categories[j].req.length > 1) {
                    rowformula = rowformula.slice(0, -1)
                    rowformula += '),'
                }
            }
            // remove last comma
            rowformula = rowformula.slice(0, -1)
            rowformula += '),"PASS","FAIL")'


            for (let j = 0; j < row.length; j++) {
                if (j == 0 || j == 3) {
                    ws.cell(3 + i, j + 1).number(row[j])
                    continue
                }
                ws.cell(i + 3, j + 1).string(row[j])
            }
            for (let j = 0; j < rowdata.length; j++) {
                // style in % with req acc desimal
                ws.cell(i + 3, j + row.length + 1).number(rowdata[j].value).style({
                    numberFormat: (rowdata[j].acc > 2 ? '0.' : '0') + '0'.repeat(rowdata[j].acc - 2) + ' %; -' + (rowdata[j].acc > 2 ? '0.' : '0') + '0'.repeat(rowdata[j].acc - 2) + ' %; -'
                })

            }
            ws.cell(i + 3, row.length + rowdata.length + 1).formula(rowformula)
        }
        const buffer = await wb.writeToBuffer()
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        })

        download(blob, `${selStandard.value}-report.xlsx`)
    }

    const download = (blob, filename) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.style.display = "none"
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
    }



    const screenshot = (width = 1000, height = 1000) => {

        const canvas = document.createElement("canvas")
        canvas.height = height
        canvas.width = width


        const ctx = canvas.getContext("2d")
        ctx.fillStyle = "#4A74A9";
        ctx.fillRect(0, 0, width, height);

        const cheight = Math.min(renderer.domElement.clientWidth * canvas.height / canvas.width, renderer.domElement.clientHeight)
        const cwidth = cheight / canvas.height * canvas.width

        ctx.drawImage(renderer.domElement,
            (renderer.domElement.clientWidth - cwidth) / 2, (renderer.domElement.clientHeight - cheight) / 2,
            cwidth * 2, cheight * 2,
            0, 0, canvas.width, canvas.height)

        const dataurl = canvas.toDataURL('image/jpeg', 0.5)
        img.value = dataurl
        return dataurl


    }

    const drawmode = ref(0)
    const selStandard = ref("")

    const rankedrooms = ref([])
    const rank = ref(0)
    const sortrooms = () => {
        if (drawmode.value != 0) { return }
        let roomsids = [...resultsData.keys()]
        const newarray = []
        let faildids = roomsids.filter(id => {
            return resultsData[id].valids[selStandard.value].points < 1
        }).sort((a, b) => {
            return resultsData[a].DF_average - resultsData[b].DF_average
        })
        let passedids = roomsids.filter(id => {
            return resultsData[id].valids[selStandard.value].points > 0
        }).sort((a, b) => {
            return resultsData[a].DF_average - resultsData[b].DF_average
        })
        newarray.push(...faildids, ...passedids)
        rankedrooms.value = newarray
        rank.value = 0


    }
    const roomNummer = ref(0)
    const drawResults = () => {
        // clean out old geometry
        results.children.forEach((ch) => {
            ch.geometry.dispose()
            ch.material.dispose()
            results.remove(ch)
        })
        results.children.forEach((ch) => {
            ch.geometry.dispose()
            ch.material.dispose()
            results.remove(ch)
        })
        // rooms.visible = false
        // console.log(results.children)


        const positions = []
        const points = []
        const colors = []
        const values = []
        const scale = []
        const labels = []

        let cs = undefined
        let pset = presets[selectedData.value]
        if (drawmode.value == 0) {
            pset = presets[selStandard.value]
        }
        if (pset == undefined) {
            pset = presets["default"]
        }
        cs = colorScale[pset.colorScale]
        if (pset.domain != undefined) {
            cs.domain(pset.domain)
        }
        if (pset.classes != undefined) {
            cs.classes(pset.classes)
        }

        if (drawmode.value == 0) {
            rooms.children.forEach((room) => {
                let color = cs(room.userData.valids[selStandard.value].points).rgb()
                color = new Color(color[0] / 255, color[1] / 255, color[2] / 255)
                room.material = new MeshBasicMaterial({
                    side: DoubleSide,
                    color: color,
                })
            })
            rooms.visible = true
            onchange()
            return
        }

        rooms.children.forEach((room) => {
            let color = cs(room.userData[selStandard.value]).rgb()
            color = new Color(0.7, 0.7, 0.7)
            room.material = new MeshBasicMaterial({
                side: DoubleSide,
                color: color,
            })
        })
        rooms.visible = false
        for (let i = 0; i < resultsData.length; i++) {
            const room = resultsData[i]

            let datavalues = []
            let average = 0
            if (typeof room[selectedData.value + "_values"] == "string") {
                datavalues = room[room[selectedData.value + "_values"] + "_values"]
            } else {
                datavalues = room[selectedData.value + "_values"]
            }

            if (
                typeof datavalues == "object" &&
                typeof datavalues[0] != "object" &&
                datavalues[0] != undefined
            ) {
                average = datavalues.reduce((a, b) => a + b, 0) / datavalues.length
            }

            if (selectedData.value == "sDA300") {
                datavalues = room["DA300_values"]
                average =
                    datavalues.filter((v) => v >= 0.5).length / datavalues.length
            }
            if (selectedData.value == "sDA100") {
                datavalues = room["DA100_values"]
                average =
                    datavalues.filter((v) => v >= 0.5).length / datavalues.length
            }

            if (selectedData.value == "sDA120") {
                datavalues = room["DA120_values"]
                average =
                    datavalues.filter((v) => v >= 0.5).length / datavalues.length
            }
            if (selectedData.value == "ASE") {
                datavalues = room["ASE_values"]
                average =
                    datavalues.filter((v) => v >= 250).length / datavalues.length
            }
            let UDIfailScale = []
            let UDIsupScale = []
            let UDIacceptScale = []
            let UDIexcessScale = []

            if (selectedData.value == "UDI") {

                datavalues = room[selectedData.value + "_values"]
                UDIfailScale = datavalues.fail
                UDIsupScale = datavalues.fail.map((v, l) => {
                    return v + datavalues.sup[l]
                })
                UDIacceptScale = UDIsupScale.map((v, l) => {
                    return v + datavalues.accept[l]
                })
                UDIexcessScale = UDIsupScale.map(() => {
                    return 1
                })
                average =
                    (datavalues.accept.reduce((a, b) => a + b, 0) /
                        datavalues.accept.length) + (datavalues.sup.reduce((a, b) => a + b, 0) /
                            datavalues.sup.length * 0.5)
            }

            const bb = new Box3()
            bb.setFromObject(room.mesh)
            const cent = new Vector3()
            bb.getCenter(cent)


            const floorHeight = Number(floors[selectedfloor.value])
            const margin = 0.1
            const lableHight = cent.y + 1.55

            if (
                lableHight > floorHeight - margin &&
                lableHight < floorHeight + margin
            ) {
                labels.push({ pos: cent, average })
            }

            for (let n = 0; n < room.SensorPoints.length; n++) {
                const point = room.SensorPoints[n]
                let value = undefined

                if (typeof datavalues == "object") {
                    if (selectedData.value == "UDI") {
                        value = datavalues.accept[n]
                    } else {
                        value = datavalues[n]
                    }
                } else {
                    value = datavalues
                }
                const pointHight = point[1] + 0.75



                if (
                    pointHight >= floorHeight - margin &&
                    pointHight <= floorHeight + margin
                ) {
                    values.push(value)

                    points.push([point[0], point[1], point[2]])
                    positions.push(point[0], point[1], point[2])

                    // UDI
                    if (selectedData.value == "UDI") {
                        scale.push(UDIexcessScale[n])

                        scale.push(UDIacceptScale[n])
                        scale.push(UDIsupScale[n])
                        scale.push(UDIfailScale[n])

                        positions.push(point[0], point[1] + 0.004, point[2])
                        positions.push(point[0], point[1] + 0.008, point[2])
                        positions.push(point[0], point[1] + 0.012, point[2])

                        // colors.push(0.91, 0.2, 0.39)

                        colors.push(255 / 255, 104 / 255, 10 / 255)
                        // colors.push(111 / 255, 207 / 255, 74 / 255)
                        // colors.push(0.2, 0.72, 0.46)
                        colors.push(0.95, 0.91, 0.11)

                        // colors.push(75 / 255, 122 / 255, 149 / 255)
                        colors.push(96 / 255, 193 / 255, 191 / 255)


                        colors.push(12 / 255, 44 / 255, 132 / 255)
                        // colors.push(63 / 255, 8 / 255, 81 / 255)

                        // colors.push(0.91, 0.2, 0.39)
                        // colors.push(0.2, 0.72, 0.46)
                        // colors.push(0.95, 0.91, 0.11)
                        // colors.push(0.28, 0.0, 0.33)
                    } else {
                        const pointColours = cs(value).rgb()
                        colors.push(
                            pointColours[0] / 255,
                            pointColours[1] / 255,
                            pointColours[2] / 255
                        )
                        scale.push(1)
                    }
                }
            }
            onchange()
        }


        if (labels.length < 1) {
            return
        }
        const geometry = new CircleGeometry(0.25, 32)
        geometry.rotateX(-Math.PI * 0.5)
        const material = new MeshBasicMaterial()

        const mesh = new InstancedMesh(geometry, material, scale.length)

        const matrix = new Matrix4()
        const offset = new Vector3()
        const orientation = new Quaternion()
        const _scale = new Vector3(1, 1, 1)
        const color = new Color()
        for (let i = 0; i < scale.length; i++) {
            offset.set(positions[i * 3], positions[i * 3 + 1], positions[i * 3 + 2])
            _scale.set(scale[i], scale[i], scale[i])
            matrix.compose(offset, orientation, _scale)

            mesh.setMatrixAt(i, matrix)
            color.setRGB(colors[i * 3], colors[i * 3 + 1], colors[i * 3 + 2])
            mesh.setColorAt(i, color)
        }

        results.add(mesh)

        // this.values = values
        // this.points = points

        const _results = []

        // Create labels for each room
        labels.forEach((label) => {
            const result = new TextBufferGeometry(
                Number(label.average * pset.scale).toFixed(pset.desimal),
                textObject,
                (textObject.size = 0.9),
                (textObject.height = 0.01)
            )
            result.computeBoundingBox()
            result.center()
            result.rotateX(-Math.PI * 0.5)
            result.rotateY(-Math.PI)

            result.translate(label.pos.x, label.pos.y + 1, label.pos.z)
            _results.push(result)
        })
        const mergedGeometry = BufferGeometryUtils.mergeBufferGeometries(_results)
        const textMaterial = new MeshBasicMaterial({
            // color: "#3751FF",
            color: "black",
            wireframe: false,
            transparent: false,
            opacity: 0.8,
        })
        const resultText = new Mesh(mergedGeometry, textMaterial)
        results.add(resultText)
    }
    const viewMode = ref(0)
    let cameraTarget = undefined

    const prediction = ref("")
    const keyP = (value) => {

        // console.log(value)
        const udi = resultsData[roomNummer.value].UDI_values
        const df = [...resultsData[roomNummer.value].DF_values].sort()
        // console.log(df)
        data.push(
            {
                DFavg: resultsData[roomNummer.value].DF_average,
                DFmin: df[0],
                DFmedi: df[Math.ceil(df.length / 2)],
                DFmax: df[df.length - 1],
                DA100: resultsData[roomNummer.value].DA100_average,
                DA300: resultsData[roomNummer.value].DA300_average,
                sDA100: resultsData[roomNummer.value].sDA100,
                sDA300: resultsData[roomNummer.value].sDA300,
                ASE: resultsData[roomNummer.value].ASE_average,
                fail: udi.fail.reduce((a, b) => a + b, 0) / udi.fail.length,
                sup: udi.sup.reduce((a, b) => a + b, 0) / udi.sup.length,
                accept: udi.accept.reduce((a, b) => a + b, 0) / udi.accept.length,
                excess: udi.excess.reduce((a, b) => a + b, 0) / udi.excess.length,
                class: value
            })
        // console.log(data)
    }
    const changeRoom = (index) => {
        const offset = 4
        roomNummer.value = index

        const room = rooms.children[index].userData
        const udi = resultsData[index].UDI_values
        const df = [...resultsData[index].DF_values].sort()
        // console.log(data)
        prediction.value = knn(data, {
            DFavg: resultsData[roomNummer.value].DF_average,
            DFmin: df[0],
            DFmedi: df[Math.ceil(df.length / 2)],
            DFmax: df[df.length - 1],
            DA100: resultsData[roomNummer.value].DA100_average,
            DA300: resultsData[roomNummer.value].DA300_average,
            sDA100: resultsData[roomNummer.value].sDA100,
            sDA300: resultsData[roomNummer.value].sDA300,
            ASE: resultsData[roomNummer.value].ASE_average,
            fail: udi.fail.reduce((a, b) => a + b, 0) / udi.fail.length,
            sup: udi.sup.reduce((a, b) => a + b, 0) / udi.sup.length,
            accept: udi.accept.reduce((a, b) => a + b, 0) / udi.accept.length,
            excess: udi.excess.reduce((a, b) => a + b, 0) / udi.excess.length,

        }, ["DFavg", "DFmin", "DFmedi", "DFmax", "DA100", "DA300", "sDA100", "sDA300", "ASE", "fail", "sup", "accept", "excess"])
        //test

        // Remove curves geometries
        curves.children.forEach((ch) => {
            curves.remove(ch)
            ch.geometry.dispose()
            ch.material.dispose()
        })
        // Create room curves
        const vertices = [
            ...room.curvePoints,
            room.curvePoints[0],
            room.curvePoints[1],
            room.curvePoints[2],
        ]
        const roomCurveGeo = new LineGeometry()
        roomCurveGeo.setPositions(vertices)
        const material = new LineMaterial({
            color: "#3751FF",
            linewidth: 2,
            visible: true,
        })
        material.resolution.set(
            _canvas.value.clientWidth / 3,
            _canvas.value.clientHeight / 3
        )
        const roomCurve = new Line2(roomCurveGeo, material)
        roomCurve.translateY(1.59)
        curves.add(roomCurve)

        const floor = floors.indexOf(
            Number(resultsData[index].SensorPoints[0][1].toFixed(2)) + 0.75
        )
        selectedfloor.value = floor

        if (viewMode.value == 0) {
            onchange()
            return
        }
        // get bounding box of object - this will be used to setup controls and camera
        const boundingBox = new Box3()
        boundingBox.setFromObject(resultsData[index].mesh)

        const size = new Vector3()
        const center = new Vector3()
        boundingBox.getSize(size)
        boundingBox.getCenter(center)

        // get the max side of the bounding box (fits to width OR height as needed )
        const maxDim = Math.max(size.x, size.y, size.z)
        const fov = camera.fov * (Math.PI / 180)
        let cameraZ = Math.abs((maxDim / 4) * Math.tan(fov * 2))
        cameraZ *= offset

        cameraTarget = { pos: center, zoffset: cameraZ }
        onchange()
    }

    let click = false
    let dclick = false
    const img = ref("")
    const pointerclick = (e) => {
        // img.value = document.body.toDataURL()
        // console.log(renderer.domElement.toDataURL())
        if (click && e.pointerType != "touch") {
            dclick = true
        }
        if (!click) {
            setTimeout(() => {
                if (!dclick) {
                    // console.log("singleclick")
                    singleClick(e)
                } else {
                    // console.log("dubbleclick")

                    dblClick(e)
                }
                click = false
                dclick = false
            }, 200)
        }
        click = true
    }
    const singleClick = (event) => {
        // console.log(mousepos)
        // console.log(event)
        if (Math.sqrt(Math.pow(mousepos.mouseX - event.clientX, 2)) > 20 ||
            Math.sqrt(Math.pow(mousepos.mouseY - event.clientY, 2)) > 20
        ) {
            return
        }


        const mouse = {}
        const raycaster = new Raycaster()
        const canvasBounds = renderer.getContext().canvas.getBoundingClientRect()
        mouse.x =
            ((event.clientX - canvasBounds.left) /
                (canvasBounds.right - canvasBounds.left)) *
            2 -
            1
        mouse.y =
            -(
                (event.clientY - canvasBounds.top) /
                (canvasBounds.bottom - canvasBounds.top)
            ) *
            2 +
            1
        raycaster.setFromCamera(mouse, camera)
        const intersects = raycaster.intersectObject(rooms, true)
        if (intersects.length > 0) {
            for (let i = 0; i < intersects.length; i++) {
                const intersect = intersects[i]
                if (
                    Number(intersect.point.y.toFixed(2)) + 0.75 <=
                    floors[selectedfloor.value]
                ) {
                    changeRoom(rooms.children.indexOf(intersect.object))
                    return
                }
            }
        }
    }
    const dblClick = (event) => {
        const mouse = {}
        const raycaster = new Raycaster()
        const canvasBounds = renderer.getContext().canvas.getBoundingClientRect()
        mouse.x =
            ((event.clientX - canvasBounds.left) /
                (canvasBounds.right - canvasBounds.left)) *
            2 -
            1
        mouse.y =
            -(
                (event.clientY - canvasBounds.top) /
                (canvasBounds.bottom - canvasBounds.top)
            ) *
            2 +
            1
        raycaster.setFromCamera(mouse, camera)
        const intersects = raycaster.intersectObject(rooms, true)
        if (intersects.length > 0) {
            for (let i = 0; i < intersects.length; i++) {
                const intersect = intersects[i]
                if (
                    Number(intersect.point.y.toFixed(2)) + 0.75 <=
                    floors[selectedfloor.value]
                ) {
                    viewMode.value = 1

                    changeRoom(rooms.children.indexOf(intersect.object))
                    return
                }
            }
        }
    }

    const savemoseclick = (e) => {
        // console.log("click", e)
        mousepos.mouseX = e.clientX
        mousepos.mouseY = e.clientY

    }

    const getPredictions = () => {
        const targets = resultsData.map((room, i) => {
            resultsData[i].recomendchange = false

            return { data: room.data }
        })
        console.log(targets)

        axios({
            baseURL: "http://localhost:8085",//url,
            url: `/utils/classifier/prediction`,
            data: {
                dataSet: targets,
                type: "roomtest",
                //  options
            },
            method: "post",
            headers: {
                // Authorization: "Bearer " + token.value,
            },
        })
            .then((resp) => {
                console.log(resp.data)
                const { predictions } = resp.data
                for (let i = 0; i < predictions.length; i++) {
                    const pred = predictions[i];
                    resultsData[i].recomend = pred.label

                }
            })
            .catch((err) => {
                console.log(err)
            })

    }



    const saveTraingdata = () => {
        for (let i = 0; i < resultsData.length; i++) {
            resultsData[i].recomendchange = false


        }
        let changedrooms = resultsData.filter(room => {
            return room.recomendchange && room.recomend != undefined

        })
        changedrooms = changedrooms.map((room, i) => {

            return { data: room.data, label: room.recomend }
        })
        console.log(changedrooms)



        const url = "https://api.otonomi.no"

        // await checkToken()
        // if (hasPerm("system.admin") && _jobId) {
        axios({
            baseURL: "http://localhost:8085",//url,
            url: `/utils/classifier/train`,
            data: {
                dataSet: changedrooms,
                type: "roomtest",
                //  options
            },
            method: "post",
            headers: {
                // Authorization: "Bearer " + token.value,
            },
        })
            .then((resp) => {
                console.log("sent")
            })
            .catch((err) => {
                console.log(err)
            })
        // }


    }


    return {
        init,
        loadModel,
        onchange,
        drawResults,
        changeRoom,
        singleClick,
        pointerclick,
        dblClick,
        iterations,
        drawmode,
        northrot,
        resultsData,
        selectedData,
        selStandard,
        selectedfloor,
        transparentMode,
        materialMode,
        floors,
        projectInfo,
        downloadprogress,
        roomNummer,
        roomNames,
        materials,
        savemoseclick,
        sortrooms,
        rankedrooms,
        rank,
        roomNamesnotsim,
        validations,
        projectConstants,
        keyP,
        prediction,
        viewMode,
        img,
        saveScreenshot,
        saveTraingdata,
        getPredictions,
        createExcel
    }
}
